module.exports = __webpack_public_path__ + "img/avatar-outline.53dacd3e.svg";